import { render, staticRenderFns } from "./StatelessTags.vue?vue&type=template&id=4018a098&"
import script from "./StatelessTags.vue?vue&type=script&lang=js&"
export * from "./StatelessTags.vue?vue&type=script&lang=js&"
import style0 from "./StatelessTags.vue?vue&type=style&index=0&id=4018a098&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports